'use client';

import Script from 'next/script';

export default function ShopMyClickTrack() {
  return (
    <script
      defer
      src='https://static.shopmy.us/Affiliates/sms_aff_clicktrack.js?domain=vivrelle.com&expires=30'
    ></script>
  );
}
